import { render } from "./GeneralSettings.vue?vue&type=template&id=7b0e924a"
import script from "./GeneralSettings.vue?vue&type=script&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&lang=js"
script.render = render

export default script